const html      = window.html;
const routes    = window.routes;

const Backbone  = window.Backbone;

import QueryString from 'querystring';
import SubjectParameters from '../../../../../business-objects/SubjectParameters';

const SubjectModel = Backbone.Model.extend({
    defaults() {
        return {
            id         : 0,
            titleCount : 0,
            name       : '',
            format     : ''
        };
    },

    toViewModel(subjectParams) {
        // Take a snapshot of the current model
        let data = this.toJSON();

        // Create a search parameters object with the current subject ID mixed in so we get correct search results
        let params = new SubjectParameters(subjectParams);
        params.subject.push(data.id);

        params.sortBy = 'newlyadded';

        params.maturityLevel = [];

        delete params.showOnlyAvailable;

        let viewModel = {
            count           : data.titleCount,
            subjectID       : data.id,
            subject         : data.name,
            format          : data.format,
            subjectLabel    : (html(`subjects.${data.id}`) || ''),
            subjectSubLabel : '',
            href            : `${window.url(routes.search)}?${QueryString.stringify(params.serialize())}`
        };

        // Generate the two part subject label if the subejct contains the ' - ' delimter
        let subjectParts = viewModel.subjectLabel.split(' - ');
        if (subjectParts.length > 1) {
            viewModel.subjectLabel      = subjectParts[1];
            viewModel.subjectSubLabel   = subjectParts[0];
        }

        return viewModel;
    }
});

export default SubjectModel;
